import { render } from "./PostMedia.vue?vue&type=template&id=70e382ca&ts=true"
import script from "./PostMedia.vue?vue&type=script&setup=true&lang=ts"
export * from "./PostMedia.vue?vue&type=script&setup=true&lang=ts"

import "./PostMedia.vue?vue&type=style&index=0&id=70e382ca&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/communityTalk/PostMedia.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "70e382ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('70e382ca', __exports__)) {
    api.reload('70e382ca', __exports__)
  }
  
  module.hot.accept("./PostMedia.vue?vue&type=template&id=70e382ca&ts=true", () => {
    api.rerender('70e382ca', render)
  })

}


export default __exports__